// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class AccountSaveUserSaveUserContactInfoRequestModel {
    'value': string;
    'isPreferred': boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof AccountSaveUserSaveUserContactInfoRequestModel>> = [
        {
            "name":     "value",
            "baseName": "value",
            "type":     "string"
        },
        {
            "name":     "isPreferred",
            "baseName": "isPreferred",
            "type":     "boolean"
        },
    ];

    static getAttributeTypeMap() {
        return AccountSaveUserSaveUserContactInfoRequestModel.attributeTypeMap;
    }
}
